import { makeAutoObservable } from 'mobx'
import { MessageContent } from '@/types/message'
import { getUserProfileAPI } from '@/servers/agent-v2'

class AgentStore {
  messagesList: MessageContent[] = []
  initMsgListData = false
  typing = false
  currentSessionId = ''
  latestSessionId = ''
  renderMsgList: MessageContent[] = []
  scrollToBottomViewMark = 1
  pendingScrollToBottomForce = false
  isStreamingOutput = false
  messageUpdateFlags: Map<string, number> = new Map()
  has_product_type = false
  has_adv = false
  is_onboarding = false
  isHistoryChatMode = false
  isProductImageMode = false
  currentProductInfo: { name?: string; timestamp?: number } | null = null
  lastEventId = ''
  isInitSessionList = false
  sessionList: {
    session_id: string
    session_name: string
    start_time: string
  }[] = []

  messageMapping: Record<
    string,
    {
      data: MessageContent
      renderIndex: number
    }
  > = {}
  nodeDisalbedStatusMap: Record<string, boolean> = {}
  chatLoadingState = {
    loading: false,
    loadingText: 'Loading'
  }
  videoLibraryVisible = false

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  resetState() {
    this.typing = false
  }

  reset() {
    this.renderMsgList = []
    this.messagesList = []
    this.currentSessionId = ''
    this.latestSessionId = ''
    this.initMsgListData = false
    this.isInitSessionList = false
    this.chatLoadingState = { loading: false, loadingText: '' }
    this.resetState()
  }

  async initUserProfileData() {
    const userProfileRes = await getUserProfileAPI()
    if (userProfileRes.code === 0) {
      this.has_adv = userProfileRes.data.has_adv
      this.is_onboarding = userProfileRes.data.is_onboarding
      this.has_product_type = userProfileRes.data.has_product_type
    }
    return userProfileRes
  }

  commitUpdateAction<T extends (store: AgentV2StoreT) => any>(updater: T): ReturnType<T> {
    return updater(this)
  }

  scrollToBottomView(force = false) {
    this.pendingScrollToBottomForce = this.pendingScrollToBottomForce || Boolean(force)
    this.scrollToBottomViewMark = this.scrollToBottomViewMark + 1
  }

  consumePendingScrollToBottomForce(): boolean {
    const v = this.pendingScrollToBottomForce
    this.pendingScrollToBottomForce = false
    return v
  }

  triggerMessageUpdate(messageId: string) {
    const current = this.messageUpdateFlags.get(messageId) || 0
    this.messageUpdateFlags.set(messageId, current + 1)
  }

  getMessageUpdateFlag(messageId: string): number {
    return this.messageUpdateFlags.get(messageId) || 0
  }

  setProductInfo(productInfo: { name?: string; timestamp?: number } | null) {
    this.currentProductInfo = Object.assign({}, this.currentProductInfo, productInfo)
  }

  setVideoLibraryVisible(visible: boolean) {
    this.videoLibraryVisible = visible
  }
}

export type AgentV2StoreT = InstanceType<typeof AgentStore>
export default new AgentStore()
